export const SEND_REQUEST_FOR_CONSULTATION = 'SEND_REQUEST_FOR_CONSULTATION';